import {
  CarouselBase,
  CarouselCard,
  Skeleton
} from 'ui'
import {
  Container,
  GradientBottom,
  GradientTop
} from './styles'
import { useGetHero } from 'api/content'
import { getThumbnail } from 'utils/thumbnails'

import Pagination from './Pagination'
import Buttons from './Buttons'


const Hero = () => {

  const { data: hero, isFetching } = useGetHero()

  if (isFetching) return (
    <Container>
      <Skeleton />
      <GradientTop />
      <GradientBottom />
    </Container>
  )

  return (
    <Container>
      <CarouselBase
        key='content'
        loop
        effect='fade'
        offsetLeft={0}
        isGradientBottom
        autoPlay={{
          delay: 6000,
          waitForTransition: true,
          disableOnInteraction: false
        }}
        renderNavigationBtns={Buttons}
        renderPagination={Pagination}
      >
        { hero.map( content => (
          <CarouselCard
            key={content.uuid}
            to={`series/${content.uuid}`}
            imgSrc={getThumbnail(content, 'hero')}
            isHoverEffect={false}
            isRounded={false}
          />
        ))}
      </CarouselBase>
      <GradientTop />
    </Container>
  )
}

export default Hero